import { lazy } from "react";
import { Dashboard, Description, ReceiptLong } from "@mui/icons-material";
import RouteName from "./Route.name";
import Constants from "../config/constants";

const DoctorDashboard = lazy(
  () => import("../views/DoctorDashboard/DoctorDashboard.view"),
);
const UserAgreement = lazy(
  () => import("../views/UserAgreement/UserAgreement.view"),
);
const PatientDetail = lazy(() => import("../views/PatientInfo/PatientDetail"));
const VitalsDetail = lazy(
  () => import("../views/Vitals/VitalsDetail/VitalsDetail.view"),
);
const AuditTrialLog = lazy(
  () => import("../views/AuditTrialLog/AuditTrialLog.view"),
);


const DietitianDashboard = lazy(
  () => import("../views/DietitiansDashboard/DietitianDashboard.view")
);

const DietitianPatientDetail = lazy(
  () => import("../views/DietitiansDashboard/PatientDetail/DietitianPatientDetail.view")
);

const dashboardRoutes = [
  {
    path: `${RouteName.PATIENT_DETAIL}:id`,
    sidebarName: "Profile",
    icon: Description,
    component: PatientDetail,
    is_sidebar: false,
    parentRoute: `${RouteName.DOCTOR_DASHBOARD}`,
  },
  {
    path: `${RouteName.VITALS_INFO}:id`,
    sidebarName: "Profile",
    icon: Description,
    component: VitalsDetail,
    is_sidebar: false,
    parentRoute: `${RouteName.DOCTOR_DASHBOARD}`,
  },
  // {
  //   path: `${RouteName.STYLE_GUIDE}`,
  //   sidebarName: "Style Guide",
  //   // icon: FormatShapes,
  //   component: StyleGuide,
  //   is_sidebar: false,
  //   is_protect: false,

  // },
  {
    path: `${RouteName.USER_AGGREEMENT}`,
    component: UserAgreement,
    is_sidebar: false,
    is_protect: false,
  },
  {
    path: RouteName.DOCTOR_DASHBOARD,
    sidebarName: "HCP Dashboard",
    icon: Dashboard,
    component: DoctorDashboard,
    is_sidebar: true,
    module: Constants.MODULES.DOCTOR_PERFORMANCE,
    permissions: ["read"],
    // parent: "admin_dashboards",
  },
  {
    path: RouteName.DIETITIANS_DASHBOARD,
    sidebarName: "Dietitians Dashboard",
    icon: Dashboard,
    component: DietitianDashboard,
    is_sidebar: true,
    // module: Constants.MODULES.PROGRAM_ADHERENCE,
    permissions: ["read"],
    // parent: "admin_dashboards",
  },

  {
    path: `${RouteName.DIETITIAN_PATIENT_DETAIL}:id`,
    sidebarName: "Dietitians Dashboard",
    icon: Dashboard,
    component: DietitianPatientDetail,
    is_sidebar: false,
    permissions: ["read"],
    parent: "admin_dashboards",
  },
  // {
  //   path: RouteName.AUDIT_CREATE,
  //   sidebarName: "Audit Trail Log",
  //   icon: ReceiptLong,
  //   component: AuditTrialLog,
  //   is_sidebar: true,
  //   parentRoute: `${RouteName.AUDIT_CREATE}`,
  // },
];

export default dashboardRoutes;
